import React, { PureComponent } from 'react'
import styled from 'styled-components'
import Question, { ISkin as IQuestionSkin } from '../question/Question'
import { ISize } from '../../helpers/data/size'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
`

const QuestionContainer = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`

interface IPreviewProps {
	activities: any[]
	skin: IQuestionSkin
	size: ISize
}

class Preview extends PureComponent<IPreviewProps> {
	buildActivities(activities: any[]) {
		return activities.map((activity: any, index: number) => {
			return (
				<QuestionContainer key={activity.uid}>
					<Question
						data={activity}
						questionIndex={index}
						skin={this.props.skin}
						gameSize={this.props.size}
						isPreview={true}
					/>
					{/*
						We are not displaying the timer for now. Keeping it since we will probably use it
						<GameTimerContainer>
						<Timer
							shouldRun={false}
							totalTime={activity.timer * 1000}
						/>
					</GameTimerContainer>*/}
				</QuestionContainer>
			)
		})
	}

	render() {
		return <Wrapper>{this.buildActivities(this.props.activities)}</Wrapper>
	}
}

export default Preview
